// extracted by mini-css-extract-plugin
export default {"notesContainer":"notesContainer-d9fQn","notesRow":"notesRow-s596t","notesList":"notesList-Orrsd","summarySeparator":"summarySeparator-tXPhw"};